var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPurpleAppIconPlaceholder = function SvgPurpleAppIconPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19139_58812",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 29,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00390625,
    width: 28,
    height: 28,
    rx: 8,
    fill: "#3A3A3C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19139_58812)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00390625,
    width: 28,
    height: 28,
    fill: "url(#paint0_linear_19139_58812)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.99609,
    y: 5,
    width: 18,
    height: 18,
    rx: 5,
    stroke: "#F2F2F7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 8.99609,
    y: 9,
    width: 10,
    height: 10,
    rx: 5,
    stroke: "#F2F2F7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1367 7L6.99458 21.1421",
    stroke: "#F2F2F7",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19139_58812",
    x1: 13.9961,
    y1: 0,
    x2: 13.9961,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#713171"
  })))));
};
export { SvgPurpleAppIconPlaceholder as ReactComponent };
export default __webpack_public_path__ + "purple-app-icon-placeholder.svg";